import { render, staticRenderFns } from "./EditContratoPage.vue?vue&type=template&id=7198988f"
import script from "./EditContratoPage.vue?vue&type=script&lang=js"
export * from "./EditContratoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports